import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CareQuoteFormPageRoutingModule } from './care-quote-form-routing.module';

import { CareQuoteFormPage } from './care-quote-form.page';
import { SharedComponentsModule } from 'src/app/components/shared-components.module';
import { DataFieldsService } from 'src/app/services/data-fields.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CareQuoteFormPageRoutingModule,
    SharedComponentsModule
  ],
  declarations: [CareQuoteFormPage],
  providers: [
    DataFieldsService
  ]
})
export class CareQuoteFormPageModule {}
